// @ts-ignore
import { LazyLoadWrapper as _LazyLoadWrapper } from "@my-scoot/exly-react-component-lib/build/esm/components/common/LazyLoadWrapper";

export const LazyLoadWrapper = _LazyLoadWrapper;
